module.exports = __webpack_public_path__ + "static/logo-211201-white-de3a92da40270926c898af39bf6ade2e.svg";